import { AbstractControl, AsyncValidatorFn, FormGroup } from '@angular/forms';
import { FieldKey } from '@core/data-access/models/dynamic-form-field/dynamic-form-field.model';
import { selectIsValidZipCode } from '@core/data-access/store/shared/shared.selectors';
import { transformFormControlSelectedCountryToCountryCode } from '@core/utils/helpers';
import { select, Store } from '@ngrx/store';
import { ZipValidationErrors } from '@shared/validation/validation-errors.model';
import { isEmpty, isNull } from 'lodash';
import { map, Observable, of, take } from 'rxjs';

export const invalidZipCodeError: ZipValidationErrors = { invalidZipCode: true };

export const zipCodeValidator =
  (store: Store, form: FormGroup): AsyncValidatorFn =>
  (control: AbstractControl): Observable<ZipValidationErrors | null> => {
    const zipCode = control.value;
    const country = form.get(FieldKey.Country)?.value;

    if (isEmpty(zipCode) || isEmpty(country)) {
      return of(null);
    }

    const countryCode = transformFormControlSelectedCountryToCountryCode(country);

    return store.pipe(
      select(selectIsValidZipCode(zipCode, countryCode)),
      map((isValid) => (isNull(isValid) || isValid ? null : invalidZipCodeError)),
      take(1)
    );
  };
